import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaUserPlus, FaSignInAlt, FaRocket, FaGraduationCap, FaCheckCircle, FaClock, FaArrowLeft } from 'react-icons/fa';
import Styles from './style.module.css';
import { imageProps } from '../../imageAssets';
import { useAuth } from '../../Context/AuthContext';

export default function TopFooter() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading || isAuthenticated) {
        return null;
    }

    return (
        <section className={Styles.topFooterSection}>
            <Container>
                <div className={Styles.topFooterCard}>
                    <div className={Styles.topFooterGlow1}></div>
                    <div className={Styles.topFooterGlow2}></div>

                    <Row className="align-items-center g-4">
                        {/* Text & Action Column (Right in RTL) */}
                        <Col lg={7} md={12} className={Styles.topFooterContent}>
                            <div className={Styles.topFooterBadge}>
                                <FaRocket className={Styles.badgeIcon} />
                                <span>ابدأ رحلة التفوق اليوم</span>
                            </div>

                            <h2 className={Styles.topFooterTitle}>
                                سجل معنا وانضم إلى <span className={Styles.highlightText}>منصة المهندس</span>
                            </h2>

                            <p className={Styles.topFooterSubtitle}>
                                استمتع بتجربة تعليمية فريدة في مادة الفيزياء مع شروحات متميزة، واختبارات تفاعلية، ومتابعة دورية تساعدك على تحقيق أعلى الدرجات.
                            </p>

                            <div className={Styles.featurePills}>
                                <div className={Styles.pill}>
                                    <FaGraduationCap className={Styles.pillIcon} />
                                    <span>شروحات مبسطة</span>
                                </div>
                                <div className={Styles.pill}>
                                    <FaCheckCircle className={Styles.pillIcon} />
                                    <span>اختبارات وتقييمات دورية</span>
                                </div>
                                <div className={Styles.pill}>
                                    <FaClock className={Styles.pillIcon} />
                                    <span>متابعة مستمرة للطلاب</span>
                                </div>
                            </div>

                            <div className={Styles.actionGroup}>
                                <Link to="/register" className={Styles.ctaPrimary}>
                                    <FaUserPlus />
                                    <span>انشاء حساب جديد</span>
                                    <FaArrowLeft className={Styles.btnArrow} />
                                </Link>

                                <Link to="/login" className={Styles.ctaSecondary}>
                                    <FaSignInAlt />
                                    <span>تسجيل الدخول</span>
                                </Link>
                            </div>
                        </Col>

                        {/* Image & Floating Graphic Column (Left in RTL) */}
                        <Col lg={5} md={12} className={Styles.topFooterVisual}>
                            <div className={Styles.imageWrapper}>
                                <img
                                    {...imageProps('webinar', '(max-width: 991px) 320px, 400px')}
                                    alt="منصة المهندس التعليمية"
                                    className={Styles.mainImg}
                                    loading="lazy"
                                />

                                <div className={`${Styles.floatingBadge} ${Styles.badgeTop}`}>
                                    <span className={Styles.badgeEmoji}>🎓</span>
                                    <div>
                                        <strong>تعلم متميز</strong>
                                        <small>أفضل الشروحات</small>
                                    </div>
                                </div>

                                <div className={`${Styles.floatingBadge} ${Styles.badgeBottom}`}>
                                    <span className={Styles.badgeEmoji}>⭐</span>
                                    <div>
                                        <strong>طريقك للتفوق</strong>
                                        <small>100% متابعة دقيقة</small>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
}
